import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatButton } from '@angular/material/button';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../../services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { NoticeBoardComponent } from '../notice-board/notice-board.component'; 

@Component({
  selector: 'app-ava-unesp',
  standalone: true,
  imports: [MatCardModule, MatButton, NoticeBoardComponent],
  templateUrl: './ava-unesp.component.html',
  styleUrls: ['./ava-unesp.component.css']
})
export class AvaUnespComponent {
  erro = '';

  constructor(private http: HttpClient, private authService: AuthService, private toastr: ToastrService) {}

  acessoMoodle() {
    this.authService.obterLinkMoodle().subscribe({
      next: (response: any) => {
        const moodleLoginUrl = response.moodleLoginUrl;
        if (moodleLoginUrl) {
          try {
            const url = new URL(moodleLoginUrl);
            window.open(url.toString(), '_blank');
          } catch (e) {
            this.toastr.error('A URL Ã© invÃ¡lida.', 'Erro');
          }
        } else {
          this.toastr.error('Nenhum link retornado.', 'Erro');
        }
      },
      error: (error) => {
        this.toastr.error('Erro ao consultar a API.', 'Erro');
      }
    });
  }
}